import {Inject, Injectable} from '@angular/core';
import {InsightTabs} from './InsightTabs';
import {BehaviorSubject, distinctUntilChanged} from 'rxjs';
import {LearningPackageStudyProgressResponseDto} from '../../../types/LearningPackageStudyProgressResponseDto';
import {TAB_NAVIGATION_SERVICE, TabNavigationService} from '../../../services/TabNavigationService';
import {NewFeedbackData} from '../../feedback/NewFeedbackData';
import {TimePeriodMode} from '../../../services/rest/api-types/TimePeriodMode';

@Injectable({
    // eslint-disable-next-line no-null/no-null
    providedIn: null
})
export class InsightPopupService {
    private currentTab = new BehaviorSubject<InsightTabs>(InsightTabs.DETAILS);
    public currentTab$ = this.currentTab.asObservable();

    public studyProgresses = new BehaviorSubject<LearningPackageStudyProgressResponseDto | undefined>(undefined);
    public studyProgresses$ = this.studyProgresses.asObservable();

    public selectedLearningPackageId = new BehaviorSubject<string | undefined>(undefined);
    public selectedLearningPackageId$ = this.selectedLearningPackageId.asObservable().pipe(distinctUntilChanged());

    private feedbackDraftSubject = new BehaviorSubject<NewFeedbackData | undefined>(undefined);
    public feedbackDraft$ = this.feedbackDraftSubject.asObservable().pipe(distinctUntilChanged());

    constructor(@Inject(TAB_NAVIGATION_SERVICE) private tabNavigationService: TabNavigationService) {
    }

    public setStudyProgresses(studyProgresses: LearningPackageStudyProgressResponseDto): void {
        this.selectedLearningPackageId.next(studyProgresses.learningPackageId);
        this.studyProgresses.next(studyProgresses);
    }

    public setTab(tab: InsightTabs): void {
        this.currentTab.next(tab);
    }

    public changeTab(newTab: InsightTabs): void {
        if (this.currentTab.getValue() !== newTab) {
            this.currentTab.next(newTab);
            const learningPackageId = this.selectedLearningPackageId.getValue()!;
            if (newTab === InsightTabs.LEARNING_HISTORY) {
                this.tabNavigationService.navigateToInsightPopupTab(learningPackageId, newTab, {timePeriodMode: TimePeriodMode.Daily});
            } else {
                this.tabNavigationService.navigateToInsightPopupTab(learningPackageId, newTab);
            }
        }
    }

    public cacheFeedbackDraft(draft: NewFeedbackData): void {
        this.feedbackDraftSubject.next({...draft});
    }

    public clearFeedbackDraft(): void {
        this.feedbackDraftSubject.next(undefined);
    }


}
